import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'empty-state',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss']
})
export class EmptyStateComponent implements OnInit {

  isHandset$: Observable<boolean>;
  mobile = false

  @Input() icon: string | null;
  @Input() title: string;
  @Input() description: string | null;
  @Input() condensed: boolean;
  @Input() sizeIcon: string;
  @Input() sizeContainer: string;
  @Input() sizeIconMobile: string;
  @Input() sizeContainerMobile: string;

  
  constructor(private readonly breakpointObserver: BreakpointObserver){
    this.isHandset$ = this.breakpointObserver.observe(Breakpoints.Handset).pipe(map(result => result.matches))
  }

  ngOnInit() {
    this.isHandset$.subscribe((res)=>{
      if(res){
        this.mobile = true
      } else{
        this.mobile = false
      }
    })
  }

}
